"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectPayer = void 0;
var _react = _interopRequireWildcard(require("react"));
var _constants = require("./constants");
var _utils = require("./utils");
var _api = require("./api");
var _SelectPayerMobile = _interopRequireDefault(require("./SelectPayerMobile/SelectPayerMobile"));
var _components = require("../../components");
var _utils2 = require("../../utils");
var _AuthProvider = require("../AuthProvider");
var _excluded = ["label", "placeholder"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var SelectPayer = function SelectPayer(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Insurance provider' : _ref$label,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? 'Select insurance provider' : _ref$placeholder,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var _useAuth = (0, _AuthProvider.useAuth)(),
    user = _useAuth.user;
  var _useInitialSortedAndG = (0, _api.useInitialSortedAndGroupedPayerOptions)(),
    options = _useInitialSortedAndG.options,
    groupedOptions = _useInitialSortedAndG.groupedOptions,
    shouldAddPayerIdInLabel = _useInitialSortedAndG.shouldAddPayerIdInLabel,
    payersLoading = _useInitialSortedAndG.payersLoading;
  var shouldShowMobileComponent = (0, _utils2.isMobile)() && !(0, _utils2.isAdmin)(user);
  var optionsChildren = (0, _react.useMemo)(function () {
    return options === null || options === void 0 ? void 0 : options.map(function (payer) {
      var label = shouldAddPayerIdInLabel ? "".concat(payer.payerName).concat(_constants.LABEL_SEPARATOR).concat(payer.payerId, ")") : payer.payerName;
      return /*#__PURE__*/_react.default.createElement(_components.SelectInput.Option, {
        value: payer.id,
        key: payer.id,
        option: payer
      }, label);
    });
  }, [options]);
  return shouldShowMobileComponent ? /*#__PURE__*/_react.default.createElement(_SelectPayerMobile.default, _extends({
    options: options,
    groupedOptions: groupedOptions
  }, restProps)) : /*#__PURE__*/_react.default.createElement(_components.SelectInput, _extends({
    label: label,
    name: "payer",
    autoComplete: "off",
    placeholder: placeholder,
    disabled: payersLoading,
    loading: payersLoading,
    sortOptions: (0, _utils.sortOptions)(shouldAddPayerIdInLabel)
  }, restProps), optionsChildren);
};
exports.SelectPayer = SelectPayer;